'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _PropertyBag2 = require('./PropertyBag');

var _PropertyBag3 = _interopRequireDefault(_PropertyBag2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * A simple property bag that exposes accessors for the most common properties related to the context in which this application runs
 *
 * @class
 * @extends {PropertyBag}
 */
var ContextProps = function (_PropertyBag) {
  (0, _inherits3.default)(ContextProps, _PropertyBag);

  /**
   * @param {String} type alias for contextType
   * @param {String} contextType the context type
   * @param {String} entityId the id of the Deskpro Entity referenced by the context
   * @param {String} locationId the id of the specific location within the UITab where the app is mounted
   * @param {String} tabId the id of this tab
   * @param {String} tabUrl the Deskpro URL of this tab
   * @param {...*} [otherProps] experimental or undocumented props
   */
  function ContextProps(_ref) {
    var type = _ref.type,
        contextType = _ref.contextType,
        entityId = _ref.entityId,
        locationId = _ref.locationId,
        tabId = _ref.tabId,
        tabUrl = _ref.tabUrl,
        otherProps = (0, _objectWithoutProperties3.default)(_ref, ['type', 'contextType', 'entityId', 'locationId', 'tabId', 'tabUrl']);
    (0, _classCallCheck3.default)(this, ContextProps);
    return (0, _possibleConstructorReturn3.default)(this, (ContextProps.__proto__ || (0, _getPrototypeOf2.default)(ContextProps)).call(this, (0, _extends3.default)({ contextType: contextType || type, entityId: entityId, locationId: locationId, tabId: tabId, tabUrl: tabUrl }, otherProps)));
  }

  /**
   * @public
   * @readonly
   *
   * @type {String}
   */


  (0, _createClass3.default)(ContextProps, [{
    key: 'contextType',
    get: function get() {
      return this.props.contextType;
    }

    /**
     * @public
     * @readonly
     *
     * @type {String}
     */

  }, {
    key: 'entityId',
    get: function get() {
      return this.props.entityId;
    }

    /**
     * @public
     * @readonly
     *
     * @type {String}
     */

  }, {
    key: 'locationId',
    get: function get() {
      return this.props.locationId;
    }

    /**
     * @public
     * @readonly
     *
     * @type {String}
     */

  }, {
    key: 'tabId',
    get: function get() {
      return this.props.tabId;
    }

    /**
     * @public
     * @readonly
     *
     * @type {String}
     */

  }, {
    key: 'tabUrl',
    get: function get() {
      return this.props.tabUrl;
    }
  }]);
  return ContextProps;
}(_PropertyBag3.default);

exports.default = ContextProps;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@deskpro/apps-sdk-core/lib/main/javascript/Core/ContextProps.js
// module id = 331
// module chunks = 0